import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Keys of theme.extend.fontSize in tailwind.config.ts. A unit test asserts
 * this list matches the config, so a new custom font size cannot silently
 * reintroduce the merge bug below.
 */
export const customFontSizeKeys = ['h1', 'h2', 'h3', 'h4', 'h5'];

/**
 * twMerge configured for our Tailwind theme. The stock twMerge only knows the
 * default scale, so it reads text-h* as a text color and drops it whenever a
 * real color class (text-white, text-grey-800, ...) is merged in. Registering
 * the custom sizes in the font-size class group fixes the classification.
 */
export const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: customFontSizeKeys }],
    },
  },
});
